import axios from 'axios'; 
import {
  getAllRewardsURL,
  getgiftDetailUrl,
  sendOTPforGiftUrl,
  verifyOTPforGiftUrl,
  giftHistoryUrl,
  getNetworkInfluencesURL,
  downloadPodUrl,
  UploadGiftImageUrl,
} from '../url';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';
import { downloadFileInAndroid, downloadFileInBrowser } from '../../../BenefitsRevamp/APIs/action';
import { toast } from 'react-toastify';

export const getAllRewardsAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const { start_date, end_date, type, manufacturer_id, user_esi_id } = data;
    const queryParams = new URLSearchParams();
    if (start_date) queryParams.append('start_date', start_date);
    if (end_date) queryParams.append('end_date', end_date);
    if (type) queryParams.append('type', type);
    if (manufacturer_id) queryParams.append('manufacturer_id', manufacturer_id);
    if (user_esi_id) queryParams.append('user_esi_id', user_esi_id);

    const url = `${getAllRewardsURL()}?${queryParams.toString()}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getNetworkInfluencerRewardsAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const { start_date, end_date, network_id, manufacturer_id, network_esi_id, user_esi_id } = data;
    const queryParams = new URLSearchParams();
    if (network_id) queryParams.append('network_id', network_id);
    if (start_date) queryParams.append('start_date', start_date);
    if (end_date) queryParams.append('end_date', end_date);
    if (end_date) queryParams.append('end_date', end_date);
    if (manufacturer_id) queryParams.append('manufacturer_id', manufacturer_id);
    if (user_esi_id) queryParams.append('user_esi_id', user_esi_id);
    if (network_esi_id) queryParams.append('network_esi_id', network_esi_id);

    const url = `${getNetworkInfluencesURL()}?${queryParams.toString()}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getgiftDetailAction = async (gift_id, type, user_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const url = `${getgiftDetailUrl()}?id=${gift_id}&type=${type}&user_esi_id=${user_esi_id}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const sendOTPforGiftAction = async (gift_id, type, user_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const url = `${sendOTPforGiftUrl()}?gift_id=${gift_id}&type=${type}&user_esi_id=${user_esi_id}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const verifyOTPforGiftAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .patch(verifyOTPforGiftUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getGiftHistoryAction = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .get(giftHistoryUrl(), {
          params: params,
          ...getTokenHeader(token),
        })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const downloadPodAction = async (gift_id, type, user_esi_id,file_name) => {
  try {
    // Get authentication token
    let token = await getToken();
    const queryParams = new URLSearchParams();
    console.log('gift_id,type,user_esi_id,file_name',gift_id,type,user_esi_id,file_name);
    queryParams.append('id', gift_id);
    queryParams.append('type', type);
    queryParams.append('user_esi_id', user_esi_id);
    
    const url = `${downloadPodUrl()}?${queryParams.toString()}`;
    console.log('download url',url);
    
    // Fetch the file
    const response = await fetch(url, {
      method: 'GET',
      ...getTokenHeader(token),
    });
    
    // Convert response to blob
    const blob = await response.blob();
    
    // Check if the response is an error message
    if (blob.type.includes('application/json')) {
      const displayName = file_name.replace('.pdf', '');
      toast.error(`No ${displayName} Found`);
      return Promise.reject(new Error(`No ${displayName} Found`));
    }
    
    // Detect if we're running in Android WebView
    const isAndroidWebView = /Android/i.test(navigator.userAgent) && window.navigator.userAgent.includes('wv');
    
    // Handle download based on environment
    if (isAndroidWebView) {
      return downloadFileInAndroid(blob, file_name);
    } else {
      return downloadFileInBrowser(blob, file_name);
    }
  } catch (err) {
    console.error('Download error:', err);
    toast.error('Download failed. Please try again.');
    return Promise.reject(err);
  }
};
export const UploadGiftImage = async (payload) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${UploadGiftImageUrl()}`, payload, {
        headers: {
          Authorization: 'Bearer ' + token,
          Accept: 'application/json',
          'content-type': 'multipart/form-data;',
        },
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch(async (e) => {
        return next(e.response.data);
      });
  });
};